import { ReactComponent as DeleteSVG } from "./Delete.svg";
import { SvgIcon } from '@mui/material';

export default function IconDelete(props) {
  return <SvgIcon {...props} component={DeleteSVG} viewBox="0 0 18 18" />;
}